import { render, staticRenderFns } from "./Entreprise.vue?vue&type=template&id=051ec2a6&"
import script from "./Entreprise.vue?vue&type=script&lang=js&"
export * from "./Entreprise.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports